export const NAVIGATION_EXPANDED_WIDTH = 202
export const NAVIGATION_COLLAPSED_WIDTH = 50
